/**
 * Client-safe ATS keyword policy shared by extract, match scoring, and UI evidence.
 *
 * Ignored entries are too generic / org-unit fluff to score or extract
 * (even via aliases like IBD).
 */

/** @type {ReadonlySet<string>} */
export const IGNORED_ATS_NORMALIZED = new Set(
  [
    "infrastructure",
    "training",
    "investment banking division",
    // Broad single-word domains — match almost any JD, dilute ATS signal
    "banking",
    "strategy",
    "retail",
    "energy",
    "treasury",
    "funding",
    "financing",
    "investing",
    "securities",
    "healthcare",
    "logistics",
    "transportation",
    "hospitality",
    "payments",
    "maturity",
    "employee benefits",
    "wellness programs",
    "career development",
    "Syndicate",
  ].map((s) => s.toLowerCase()),
);

/**
 * @param {string | null | undefined} value
 */
export function isIgnoredAtsKeyword(value) {
  const key = String(value || "")
    .trim()
    .toLowerCase();
  return Boolean(key && IGNORED_ATS_NORMALIZED.has(key));
}
